import { Container, Text, TextMetrics, TextStyle } from 'pixi.js';
import { convertHexToNumber, SVG, SVGBaseConfig } from './svg-element';
import { TextShape } from '../text/text-shape';
import { SubtitleElement } from '../../subtitle/subtitle-element';
import { StoryBoardItem } from '../../../../services/canvas/story-board/story-board-item';
import { FontWeight } from '../../../../elements/resource/types/shape.type';

export interface TextSVGConfig extends SVGBaseConfig {
  text: string;
  fontSize: number;
  fontStyle?: 'normal' | 'italic' | 'oblique';
  wordWrap?: boolean;
  wordWrapWidth?: number;
  fontWeight?: FontWeight;
  letterSpacing?: number;
  lineHeight?: number;
  fontFamily?: string;
}
export class TextElement extends SVG<TextSVGConfig, Text> {
  get text() {
    return this.config.text;
  }

  get fontStyle() {
    return this.config.fontStyle;
  }

  get strokeWidth() {
    return this.config['stroke-width'];
  }

  get fontFamily() {
    return this.config.fontFamily || 'Goldman';
  }

  get fontSize() {
    return this.config.fontSize;
  }

  get wordWrap() {
    return this.config.wordWrap;
  }

  get wordWrapWidth() {
    return this.config.wordWrapWidth;
  }

  get fontWeight() {
    return this.config.fontWeight || 'normal';
  }

  get lineHeight() {
    return this.config.lineHeight;
  }

  get letterSpacing() {
    return this.config.letterSpacing;
  }

  // get element() {
  //   return this._element as Text;
  // }

  constructor(
    parent: TextShape | SubtitleElement | StoryBoardItem,
    container: Container,
    config: TextSVGConfig,
  ) {
    super(parent, container, config);
    container.addChild(this.element);
    this.updateAttr();
  }

  initElement(): void {
    this._element = new Text();
  }
  updateAttr() {
    if (!this._element) {
      return;
    }

    this._element.text = this.text;

    this._element.style = {
      fontSize: this.fontSize,
      fontStyle: this.fontStyle,
      // fontWeight: '500',
      // fontWeight: 'bold' || this.fontWeight,
      fontWeight: this.fontWeight,
      fill: this.fill || convertHexToNumber('#808080'),
      stroke: convertHexToNumber(this.stroke) || '#000000',
      strokeThickness: this.strokeWidth || 0,
      lineJoin: 'round',
      align: 'center',
      lineHeight: this.lineHeight || this.fontSize,
      fontFamily: this.fontFamily,
    };

    this._element.alpha = this.opacity == undefined ? 1 : this.opacity;

    if (this.wordWrap) {
      this._element.style.wordWrap = this.wordWrap;
    }

    if (this.wordWrapWidth) {
      this._element.style.wordWrapWidth = this.wordWrapWidth;
    }

    if (this.letterSpacing) {
      this._element.style.letterSpacing = this.letterSpacing;
    }

    if (this.x !== undefined || this.y !== undefined) {
      this._element.setTransform(this.x, this.y);
      this._element.position._x = this.x;
      this._element.position._y = this.y;
    }
  }

  getBounds() {
    const metric = TextMetrics.measureText(
      this.text,
      new TextStyle(this._element.style),
    );
    return {
      width: metric.maxLineWidth,
      height: metric.lineHeight,
    };
  }
}
